{
  "ADMIN": {
    "ADMIN": "Admin",
    "CREATEEDITTRIAL": "Opret/rediger afprøvning",
    "UPLOADFILEFORTRIAL": "Upload fil for afprøvning"
  },
  "GENERAL": {
    "AVERAGEWEIGHT": "Gennemsnitsvægt",
    "AVERAGEWEIGHTSHORT": "Gns.vægt",
    "AVERAGEWEIGHTPERPEN": "Gns.vægt / sti",
    "BACK": "Tilbage",
    "BATCH": "Hold",
    "BUILDING": "Bygning",
    "CODE": "Kode",
    "DATE": "Dato",
    "EDIT": "Rediger",
    "ENDDATE": "Slutdato",
    "ENDWEIGHING": "Slutvejning",
    "FEED": "Foder",
    "FEEDSHORT": "Kom",
    "FILTER": "Filter",
    "FINALWEIGHING": "Slutvejning",
    "FROM": "Fra",
    "GENDER": "Køn",
    "GROUP": "Gruppe",
    "INTERIMWEIGHING": "Mellemvejning",
    "INITIAL": "Indsættelse",
    "INITIALS": "Initialer",
    "INITIALWEIGHING": "Indsættelsesvejning",
    "NEXTBATCH": "Næste hold",
    "NODATAMATCHESFILTER": "Ingen data matcher filteret",
    "NUMBEROFANIMALS": "Antal",
    "NUMBEROFPIGS": "Antal grise",
    "OVERVIEW": "Overblik",
    "PEN": "Sti",
    "PENS": "Stier",
    "REASON": "Årsag",
    "REMOVALS": "Udtagning",
    "SAVE": "Gem",
    "SAVEANDPREVIOUSTEAM": "Gem & til forrige hold",
    "SAVEANDNEXTTEAM": "Gem & til næste hold",
    "SAVEANDTOOVERVIEW": "Gem og til oversigt",
    "SECTION": "Sektion",
    "SECTIONS": "Sektioner",
    "SECTIONSLOWERCASE": "sektioner",
    "SIGNOUT": "Log ud",
    "SUM": "I alt",
    "SYNCHRONIZE": "Synkroniser",
    "TESTSTATION": "Forsøgsstation",
    "TRIAL": "Afprøvning",
    "TRIALNUMBERSHORT": "Afp. nr.",
    "TRIALS": "Afprøvninger",
    "UNKNOWN": "ukendt",
    "WEIGHTINKG": "Vægt (kg)"
  },
  "SNACKBAR":  {
    "OK": "OK"
  },
  "SYNC": {
    "SYNCHRONIZE": "Synkroniser",
    "DEBUG": "Avancerede indstillinger",
    "DELETE_SYNC": "Slet lokale synk data",
    "DELETE_STORE": "Slet lokale store data",
    "SYNCHRONIZATION": "Synkronisering",
    "SYNCHRONIZATIONFAILURE": "Synkronisering mislykkedes",
    "SYNCHRONIZATIONSUCCESS": "Synkronisering fuldendt",
    "SYNCHRONIZATIONNOTNEEDED": "Intet at synkronisere",
    "DELETE_SYNC_SUCCESS": "Lokale synk data slettet",
    "DELETE_STORE_SUCCESS": "Lokale store data slettet"
  }
}
